import { FormControl, FormGroup, FormArray } from '@angular/forms';

import * as Services from '@shared/core/services';

import { Observable, pipe } from 'rxjs';
import { map, delay, take } from 'rxjs/operators';
import { ILoyaltyAppCountryAssignmentModel, IMemberModel } from '@shared/state';

const findControl = (formControl: FormGroup | FormArray, search: string) => {
    if (!formControl) return null;

    return formControl.controls[search] || findControl(formControl.parent, search);
};

export const cellPhoneTakenValidator = (membersService: Services.MembersService,
    countryPrefixField: string = null,
    countries: ILoyaltyAppCountryAssignmentModel[] = [],
    delayResponse: number = 0) => (control: FormControl): Observable<OLO.Common.IValidators> | Promise<OLO.Common.IValidators> => {
    if (!control.value) {
        return Promise.resolve(null);
    }

    let MobilePhoneCountryId: number = 222;
    if (countryPrefixField && countries) {
        const countryControl: FormControl = findControl(control.parent, countryPrefixField);
        if (countryControl) {
            countries.forEach(obj => {
                if (obj.Id === countryControl.value) {
                    MobilePhoneCountryId = obj.Id;
                }
            });
        }
    }

    const __commonPipe = (message: OLO.Common.IValidators, delayRes: number = 0) => pipe(
        delay(delayRes),
        take(1),
        map(isAvailable => isAvailable ? null : message)
    );

    const msg: OLO.Common.IValidators = { phoneTaken: 'Phone is taken' };

    return membersService.validateMemberByProperty(control.value, MobilePhoneCountryId, OLO.Enums.LOGIN_TYPE.MOBILE_PHONE_BASED_LOGIN)
        .pipe(__commonPipe(msg, delayResponse));
};

export const cellPhoneTakenForSignInValidator = (membersService: Services.MembersService,
    countryPrefixField: string = null,
    countries: ILoyaltyAppCountryAssignmentModel[] = [], delayResponse: number = 0) =>
    (control: FormControl): Observable<OLO.Common.IValidators> | Promise<OLO.Common.IValidators> => {
        if (!control.value || control.value.length !== 10) {
            return Promise.resolve(null);
        }

        let MobilePhoneCountryId: number = 222;
        if (countryPrefixField && countries) {
            const countryControl: FormControl = findControl(control.parent, countryPrefixField);
            if (countryControl) {
                countries.forEach(obj => {
                    if (obj.Id === countryControl.value) {
                        MobilePhoneCountryId = obj.Id;
                    }
                });
            }
        }

        const __commonPipe = (message: OLO.Common.IValidators, delayRes: number = 0) => pipe(
            delay(delayRes),
            take(1),
            map(isRegistered => isRegistered ? null : message)
        );

        const msg: OLO.Common.IValidators = { phoneNotRegistered: 'Phone is not registered' };

        return membersService.isMobileNumberRegistered(control.value, MobilePhoneCountryId)
            .pipe(__commonPipe(msg, delayResponse));
    };


export const cellPhoneSelfUpdateValidator = (membersService: Services.MembersService,
    currentMember: Observable<IMemberModel>,
    countryPrefixField: string = null,
    countries: ILoyaltyAppCountryAssignmentModel[] = []) => (control: FormControl): Observable<OLO.Common.IValidators> | Promise<OLO.Common.IValidators> => {
    if (!control.value) return Promise.resolve(null);

    return new Promise(resolve => {

        currentMember
            .pipe(
                take(1)
            ).subscribe(member => {
                let MobilePhoneCountryId: number = null;
                if (countryPrefixField && countries) {
                    const countryControl: FormControl = findControl(control.parent, countryPrefixField);
                    if (countryControl) {
                        countries.forEach(obj => {
                            if (obj.Id === countryControl.value) {
                                MobilePhoneCountryId = obj.Id;
                            }
                        });
                    }
                }

                if (!member || member.MobilePhone === control.value) return resolve(null);

                membersService.isMobileNumberRegistered(control.value, MobilePhoneCountryId).subscribe(responses => {
                    if (responses) {
                        return resolve({
                            cellPhoneUpdateTaken: 'Phone is taken'
                        });
                    }

                    resolve(null);
                });
            });

    });
};
